import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from "@angular/router";
import { NbToastrService } from "@nebular/theme";
import { Globals } from "../globals";
import { SetupService } from "../services/setup.service";
import * as _ from "underscore";
import * as __ from "lodash";
import { filter, take } from 'rxjs/operators';
import { firstValueFrom, combineLatest } from 'rxjs'

@Injectable({
  providedIn: "root",
})
export class RegistrationRoutingGuard implements CanActivate {
  constructor(
    public globals: Globals,
    private setupService: SetupService,
    private toastrService: NbToastrService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    console.info("Wait for Ready$")
    await firstValueFrom(combineLatest([
      this.setupService.userReady$,
      this.setupService.stateReady$
    ])
    .pipe(
      filter(([userReady, stateReady]) => userReady && stateReady), // only proceed when data is ready
      take(1)
    ));
    console.info("Got Ready$")
    console.info(this.setupService.user)
    // Activation logic
    if (this.setupService.user.waiting_list_number > 0) {
      this.showNotification("You're on the waiting list (N° " + this.setupService.user.waiting_list_number + "), you can't access this page yet 😞", "warning");
      console.info("1")
      return false;
    } else if (this.setupService.user.registration_state == "notStarted") {
      this.showNotification("You need to register before accessing everything else 🙄", "warning");
      console.info("2")
      return false;
    } else if (this.setupService.user.registration_state == "quickProfile") {
      this.showNotification("You need to register before accessing everything else 🙄", "warning");
      console.info("3")
      return false;
    } else if (this.setupService.user.registration_state == "prepayment") {
      this.showNotification("You need to prepay your WESKI before continuing your registration 💸", "warning");
      console.info("4")
      return false;
    } else if (state.url != "/registration/profile" && !this.setupService.user.completed_registrations.includes("profile")) {
      this.showNotification("You need to finish your Profile before everything else 🙄", "warning");
      console.info("5")
      return false;
    } else {
      console.info("SWITCH")
      switch (state.url) {
        case "/registration/profile":
          if (_.findWhere(this.setupService.state.modules, { name: "Profil" }).state == "closed") {
            this.showNotification("The Profile page is currently closed, please try again later ☠️", "danger");
            return false;
          }
          break;
        case "/registration/transportation":
          if (_.findWhere(this.setupService.state.modules, { name: "Transports" }).state == "closed") {
            this.showNotification("The Transportation page is currently closed, please try again later ☠️", "danger");
            return false;
          }
          break;
        case "/registration/activities":
          if (_.findWhere(this.setupService.state.modules, { name: "Activités" }).state == "closed") {
            this.showNotification("The Activities page is currently closed, please try again later ☠️", "danger");
            return false;
          }
          break;
        case "/registration/skipass":
          if (_.findWhere(this.setupService.state.modules, { name: "Forfaits" }).state == "closed") {
            this.showNotification("The Skiass page is currently closed, please try again later ☠️", "danger");
            return false;
          }
          break;
        case "/registration/equipment":
          if (!this.setupService.user.completed_registrations.includes("skipass")) {
            this.showNotification("You need to choose your Pass before choosing your Equipment ⛷️", "warning");
            return false;
          } else if (_.findWhere(this.setupService.state.modules, { name: "Matériel" }).state == "closed") {
            this.showNotification("The Equipment page is currently closed, please try again later ☠️", "danger");
            return false;
          }
          break;
        case "/registration/terms":
          let noPass =
            __.reduce(
              this.setupService.user.pass,
              function (sum, pass) {
                return sum + pass.days;
              },
              0
            ) == 0;

          if (
            _.findWhere(this.setupService.state.modules, {
              name: "Termes & Conditions",
            }).state == "closed"
          ) {
            this.showNotification("The Terms & Conditions page is currently closed, please try again later ☠️", "danger");
            return false;
          } else if (
            !this.setupService.user.completed_registrations.includes("profile") ||
            !this.setupService.user.completed_registrations.includes("transport") ||
            !this.setupService.user.completed_registrations.includes("skipass") ||
            (!this.setupService.user.completed_registrations.includes("equipment") && !noPass)
          ) {
            this.showNotification(
              "You need to finish your Profile, Transportation, Activities, Pass and Equipment choices before accepting the terms 🙈",
              "warning"
            );
            return false;
          }
          break;
        case "/registration/bedrooms":
          if (_.findWhere(this.setupService.state.modules, { name: "Chambres" }).state == "closed") {
            this.showNotification("The Bedroom is currently closed, please try again later ☠️", "danger");
            return false;
          } else if (!this.setupService.user.completed_registrations.includes("terms")) {
            this.showNotification("You need to finish the rest of your registration and accept the terms & conditions before choosing your room 📜", "warning");
            return false;
          }
          break;
        default:
          console.info("Default switch case")
          return false;
      }
    }

    return true;
  }

  showNotification(message, status, position: any = "bottom-right") {
    this.toastrService.show("", message, {
      status: status,
      hasIcon: false,
      position: position,
    });
  }
}
